// extracted by mini-css-extract-plugin
export default {"Paid":"Update_Paid__jkRQU"};